// extracted by mini-css-extract-plugin
export var joinPageBgHalf = "pageJoin-module--joinPageBgHalf--oxohG";
export var joinPageBgHalfPolygon = "pageJoin-module--joinPageBgHalfPolygon--H45jW";
export var page = "pageJoin-module--page--Bw91+";
export var top = "pageJoin-module--top--mfzFg";
export var unit = "pageJoin-module--unit--pemnT";
export var flexEnd = "pageJoin-module--flexEnd--N-M1r";
export var topPadding = "pageJoin-module--topPadding--LaXMD";
export var mdLine = "pageJoin-module--mdLine--Jzgs3";
export var bottom = "pageJoin-module--bottom--L5IuE";